module.exports = __webpack_public_path__ + "images/edge-old-3.jpg?ff66c0476c821fcb6e3ebb1ab8fc6151";